export default __webpack_public_path__ + "static/media/o2.60df742f.png";